export default __webpack_public_path__ + "assets/resizedLevis-min.d7d6104d.webp";